var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{staticClass:"mt-4",attrs:{"rules":[_vm.rules.email],"label":"Neue E-Mail-Adresse","placeholder":"Neue e-mail-Adresse","type":"name","autocomplete":"new-email","loading":_vm.email.length < 0},on:{"input":_vm.inputChanged},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }